/**
 * HomeScreenPreview — tiny mock of an iOS/Android home-screen icon grid that
 * shows the real GoalDigger app icon nestled between neutral placeholder
 * icons. Helps the user visualize what they'll get after installing.
 */
export function HomeScreenPreview() {
  return (
    <div className="mt-3 rounded-xl border border-border bg-gradient-to-b from-sky-100 to-sky-200 dark:from-slate-800 dark:to-slate-900 p-3 shadow-inner">
      <div className="grid grid-cols-4 gap-2.5 place-items-center">
        {/* 8 placeholder app tiles + 1 highlighted GoalDigger tile */}
        <PlaceholderTile color="bg-emerald-400" />
        <PlaceholderTile color="bg-rose-400" />
        <PlaceholderTile color="bg-indigo-400" />
        <PlaceholderTile color="bg-amber-400" />
        <GoalDiggerTile />
        <PlaceholderTile color="bg-violet-400" />
        <PlaceholderTile color="bg-cyan-400" />
        <PlaceholderTile color="bg-pink-400" />
      </div>
      <p className="mt-2 text-center text-[10px] text-muted-foreground">
        Your phone after install — one tap to open
      </p>
    </div>
  );
}

function PlaceholderTile({ color }: { color: string }) {
  return (
    <div className="flex flex-col items-center gap-1">
      <div className={`h-9 w-9 rounded-[10px] ${color} opacity-60 shadow-sm`} />
      <div className="h-1.5 w-7 rounded-full bg-white/50 dark:bg-white/20" />
    </div>
  );
}

function GoalDiggerTile() {
  return (
    <div className="flex flex-col items-center gap-1 relative">
      <div className="absolute -inset-1 rounded-[14px] ring-2 ring-orange-500 animate-pulse" aria-hidden />
      <img
        src="/logo-icon.png"
        alt="GoalDigger app icon"
        className="h-9 w-9 rounded-[10px] shadow-md relative"
        loading="lazy"
        decoding="async"
      />
      <div className="text-[8px] font-bold text-foreground relative">GoalDigger</div>
    </div>
  );
}
